import React, { useState } from 'react';
import { MetricPermissionModel } from '../../../types/api/moderators';
import { MetricType, getMetricTitle } from '../../../types/api/metrics/metricsType';
import { Text, Stack, Button } from '@primer/react';
import { ChevronLeftIcon } from '@primer/octicons-react';

interface MetricPermissionsModalProps {
    permissions: MetricPermissionModel;
    didPermissionsSelected: (permissions: MetricPermissionModel) => void;
    onDismiss: () => void;
}

export const MetricPermissionsModal: React.FC<MetricPermissionsModalProps> = ({
    permissions,
    didPermissionsSelected,
    onDismiss
}) => {
    const [selectedPermissions, setSelectedPermissions] = useState<MetricPermissionModel>(permissions);

    const handlePermissionToggle = (metricType: MetricType) => {
        const newSelected = {
            ...selectedPermissions,
            [metricType]: !selectedPermissions[metricType]
        };
        setSelectedPermissions(newSelected);
        didPermissionsSelected(newSelected);
    };

    const handleSelectAll = () => {
        const metricTypes = Object.keys(selectedPermissions) as MetricType[];
        const allSelected = metricTypes.every(type => selectedPermissions[type]);

        const newSelected = metricTypes.reduce((acc, type) => ({
            ...acc,
            [type]: !allSelected
        }), {} as MetricPermissionModel);

        setSelectedPermissions(newSelected);
        didPermissionsSelected(newSelected);
    };

    const metricTypes = Object.keys(selectedPermissions) as MetricType[];
    const allSelected = metricTypes.every(type => selectedPermissions[type]);
    const someSelected = metricTypes.some(type => selectedPermissions[type]);

    return (
        <div>
            <div>
                <Stack justify="space-between" direction="horizontal">
                    <Stack direction="horizontal">
                        <Button
                            leadingVisual={ChevronLeftIcon}
                            variant='invisible'
                            onClick={onDismiss}>
                            <Text className='block mb-[1.5px]'>Просмотр доступных метрик</Text>
                        </Button>
                    </Stack>
                </Stack>
                <Stack className="mt-3 h-[360px] block">
                    <div className="space-y-6 overflow-auto mb-4">
                        <label className="flex items-center cursor-pointer border-b pb-2">
                            <input
                                type="checkbox"
                                checked={allSelected}
                                ref={(el) => {
                                    if (el) el.indeterminate = someSelected && !allSelected;
                                }}
                                onChange={handleSelectAll}
                                className="ml-4 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                            />
                            <Text
                                fontSize={14}
                                fontWeight="medium"
                                color="fg.default"
                                className="ml-3"
                                lineHeight="medium">
                                Выбрать все
                            </Text>
                        </label>
                        <div className="ml-4 mr-4 space-y-3">
                            {metricTypes.map((metricType) => (
                                <label key={metricType} className="flex items-center cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={selectedPermissions[metricType]}
                                        onChange={() => handlePermissionToggle(metricType)}
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                                    />
                                    <Text
                                        fontSize={14}
                                        fontWeight="medium"
                                        color="fg.default"
                                        className="ml-3"
                                        lineHeight="medium">
                                        {getMetricTitle(metricType)}
                                    </Text>
                                </label>
                            ))}
                        </div>
                    </div>
                </Stack>
            </div>
        </div>
    );
};